/* nc-cart: utdragbar varukorg för NordComfy. Markup/data i snippets/nc-cart.liquid. */
(function () {
  var dataEl = document.getElementById('nc-cart-data');
  var root = document.getElementById('nc-cart');
  if (!dataEl || !root) return;

  var D = JSON.parse(dataEl.textContent);
  var T = D.t;
  var ROOT = D.root.replace(/\/?$/, '/');
  var RESERVE_MS = 10 * 60 * 1000;
  var KEY = 'nc_cart_exp';
  var PROT = D.protection && D.protection.variant;

  var panel = root.querySelector('.nc-cart__panel');
  var titleEl = root.querySelector('#nc-cart-title');
  var timerEl = root.querySelector('[data-nc-timer]');
  var bodyEl = root.querySelector('[data-nc-body]');
  var footEl = root.querySelector('[data-nc-foot]');
  root.querySelector('.nc-cart__close').setAttribute('aria-label', T.close);

  var cart = null;
  var tick = null;
  var lastFocus = null;
  var nativeFetch = window.fetch.bind(window);

  /* ---------- hjälpare ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var v = cents / 100;
    var cur = (cart && cart.currency) || 'SEK';
    var frac = v % 1 === 0 ? 0 : 2;
    if (cur === 'SEK' || cur === 'NOK' || cur === 'DKK') {
      return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: frac, maximumFractionDigits: 2 }).format(v) + ' kr';
    }
    return new Intl.NumberFormat(D.nb ? 'nb-NO' : 'sv-SE', { style: 'currency', currency: cur }).format(v);
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* "Knästöd – Köp 2 få 1 gratis (3 för 499)" -> "Köp 2, få 1 gratis" */
  function tag(title) {
    var m = String(title).match(/\s[–-]\s(.+?)\s*(\(|$)/);
    var s = m ? m[1] : String(title);
    s = s.replace(/^Köp (\d+(?: par)?) få/i, 'Köp $1, få');
    /* Rabattitlarna i Admin är svenska – norska kunder ska inte se "st" och "för". */
    if (D.nb) {
      s = s.replace(/^Köp/i, 'Kjøp')
           .replace(/(\d+)\s*st\b/gi, '$1 stk')
           .replace(/\bför\b/gi, 'for');
    }
    return s;
  }
  /* Parprodukter säljs bara i hela par: tiers[handle].per = antal styck per par,
     och därmed både minsta antal och steg i +/- -väljaren. per = 1 -> vanlig styckvara. */
  function stepFor(handle) {
    var t = handle && D.tiers && D.tiers[handle];
    return t && t.per > 1 ? t.per : 1;
  }
  /* Antalen mellan två mängdrabatter har inget eget pris (4 st knästöd kostade 997 kr),
     så för parprodukter hoppar +/- mellan rabattstegen i stället för att gå 2 i taget.
     Ovanför det största steget fortsätter det med hela par. Katarinas stege 2026-09-16. */
  function tierSteps(handle) {
    var t = handle && D.tiers && D.tiers[handle];
    if (!t || !(t.per > 1) || !t.steps || !t.steps.length) return null;
    return t.steps.map(function (s) { return s[0]; }).sort(function (a, b) { return a - b; });
  }
  function qtyUp(handle, q) {
    var s = tierSteps(handle), i;
    if (s) for (i = 0; i < s.length; i++) if (s[i] > q) return s[i];
    return q + stepFor(handle);
  }
  function qtyDown(handle, q) {
    var s = tierSteps(handle), i;
    if (s) {
      if (q > s[s.length - 1]) return Math.max(q - stepFor(handle), s[s.length - 1]);
      for (i = s.length - 1; i >= 0; i--) if (s[i] < q) return s[i];
      return 0;
    }
    return q - stepFor(handle);
  }
  /* Närmaste giltiga antal uppåt: ett rabattsteg, annars ett helt par. Alltid uppåt,
     så kunden aldrig får betala mer än hen redan sett. */
  function qtyFix(handle, q) {
    var s = tierSteps(handle), per = stepFor(handle), i;
    if (per === 1) return q;
    if (s) {
      for (i = 0; i < s.length; i++) if (q <= s[i]) return s[i];
    }
    return q % per ? Math.ceil(q / per) * per : q;
  }
  function store(fn) {
    try { return fn(); } catch (e) { return null; }
  }
  function getExp() { return Number(store(function () { return localStorage.getItem(KEY); })) || 0; }
  function setExp(v) { store(function () { v ? localStorage.setItem(KEY, String(v)) : localStorage.removeItem(KEY); }); }

  function api(path, body) {
    var opts = { headers: { Accept: 'application/json', 'X-NC-Cart': '1' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(ROOT + path, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || T.error);
        return j;
      });
    });
  }

  /* ---------- rendering ---------- */
  function productCount(c) {
    return c.items.reduce(function (n, it) { return it.variant_id === PROT ? n : n + it.quantity; }, 0);
  }

  function renderTimer() {
    var left = getExp() - Date.now();
    if (!cart || productCount(cart) === 0) { timerEl.hidden = true; return; }
    timerEl.hidden = false;
    if (left <= 0) {
      timerEl.classList.add('is-expired');
      timerEl.textContent = T.expired;
      clearInterval(tick); tick = null;
      return;
    }
    var s = Math.ceil(left / 1000);
    var mm = String(Math.floor(s / 60)).padStart(2, '0');
    var ss = String(s % 60).padStart(2, '0');
    timerEl.classList.remove('is-expired');
    timerEl.innerHTML = esc(T.reserved) + ' <strong>' + mm + ':' + ss + '</strong>';
  }
  function startTimer() {
    renderTimer();
    if (!tick && getExp() > Date.now()) tick = setInterval(renderTimer, 1000);
  }

  function lineHTML(it) {
    var step = stepFor(it.handle);
    var down = qtyDown(it.handle, it.quantity);
    var up = qtyUp(it.handle, it.quantity);
    var lock = step > 1 && down < step; /* minst ett par – ta bort med papperskorgen */
    var strike = it.original_line_price;
    var final = it.final_line_price;
    var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; });
    var tags = (it.line_level_discount_allocations || []).map(function (a) {
      return '<span class="nc-cart__tag">' + icoTag + esc(tag(a.discount_application.title)) + '</span>';
    }).join('');
    return (
      '<li class="nc-cart__item" data-key="' + esc(it.key) + '">' +
        '<a class="nc-cart__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="nc-cart__info">' +
          '<a class="nc-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          opts.map(function (o) { return '<p class="nc-cart__opt">' + esc(o.name) + ': ' + esc(o.value) + '</p>'; }).join('') +
          '<div class="nc-cart__qty">' +
            '<button type="button" data-nc-qty="' + Math.max(down, 0) + '"' + (lock ? ' disabled' : '') + ' aria-label="−">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-nc-qty="' + up + '" aria-label="+">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="nc-cart__del" data-nc-qty="0" aria-label="' + esc(T.remove) + '">' + icoTrash + '</button>' +
        '<div class="nc-cart__price">' +
          '<p>' + (strike > final ? '<s>' + money(strike) + '</s> ' : '') + '<strong>' + money(final) + '</strong></p>' +
          (strike > final ? '<p class="nc-cart__save">(' + esc(T.save) + ' ' + money(strike - final) + ')</p>' : '') +
          tags +
        '</div>' +
      '</li>'
    );
  }

  /* ---------- fri frakt + uppgradering till nästa mängdrabatt ---------- */
  function unitLabel(q, per) {
    if (per > 1 && q % per === 0) return (q / per) + ' ' + T.pair;
    return q + ' ' + T.piece;
  }

  /* Billigaste steget upp som tar kundvagnen över gränsen för fri frakt.
     Per produkt tas det billigaste kvalificerande steget (Katarinas val 2026-09-16 –
     hon vill se det lilla mellanskillnadsbeloppet, 61 kr, inte 160 kr);
     finns flera produkter väljs den som kostar minst extra. */
  function bestUpgrade() {
    if (!D.ship || !D.tiers) return null;
    var byProduct = {};
    cart.items.forEach(function (it) {
      if (it.variant_id === PROT) return;
      var tier = D.tiers[it.handle];
      if (!tier) return;
      var e = byProduct[it.handle] || (byProduct[it.handle] = { tier: tier, qty: 0, total: 0, key: null, keyQty: 0 });
      e.qty += it.quantity;
      e.total += it.final_line_price;
      if (it.quantity > e.keyQty) { e.keyQty = it.quantity; e.key = it.key; }
    });
    var best = null;
    Object.keys(byProduct).forEach(function (h) {
      var e = byProduct[h];
      if (!e.key) return;
      var top = null;
      e.tier.steps.forEach(function (step) {
        var q = step[0], price = step[1];
        if (q <= e.qty) return;
        if (cart.total_price - e.total + price < D.ship.free) return;
        if (top && price >= top[1]) return;
        top = step;
      });
      if (!top) return;
      /* Ett steg kan ha en egen etikett (steg[2]) – knästödets kort räknar par som
         köpta + gratis, så 4 st heter "3 par". Saknas etikett räknas den ur antalet. */
      var cur = null;
      e.tier.steps.forEach(function (step) { if (step[0] === e.qty) cur = step; });
      var extra = top[1] - e.total;
      if (best && extra >= best.extra) return;
      best = {
        key: e.key,
        newQty: e.keyQty + (top[0] - e.qty),
        extra: extra,
        oldPrice: e.total,
        newPrice: top[1],
        oldLabel: (cur && cur[2]) || unitLabel(e.qty, e.tier.per),
        newLabel: top[2] || unitLabel(top[0], e.tier.per)
      };
    });
    return best;
  }

  function shipHTML() {
    if (!D.ship) return '';
    var left = D.ship.free - cart.total_price;
    var pct = left <= 0 ? 100 : Math.max(2, Math.round((cart.total_price / D.ship.free) * 100));
    var bar = '<div class="nc-cart__ship-bar"><span style="width:' + pct + '%"></span></div>';

    if (left <= 0) {
      return '<div class="nc-cart__ship is-free">' + icoTruck +
        '<p class="nc-cart__ship-txt">' + esc(T.shipFree) + '</p>' + bar + '</div>';
    }

    return '<div class="nc-cart__ship">' + icoTruck +
      '<p class="nc-cart__ship-txt">' + T.shipLeft.replace('{v}', '<strong>' + money(left) + '</strong>') + '</p>' +
      bar + '</div>';
  }

  /* Uppgraderingskortet renderas under varulistan (Katarinas val 2026-09-16)
     så att det ligger närmast summan och kassaknappen. */
  function upgradeHTML() {
    if (!D.ship || cart.total_price >= D.ship.free) return '';

    var up = bestUpgrade();
    if (!up) return '';

    var net = up.extra - D.ship.cost;
    var title = (net > 0 ? T.upTitle : T.upCheap)
      .replace('{extra}', '<strong>' + money(Math.abs(net)) + '</strong>')
      .replace('{new}', '<strong>' + esc(up.newLabel) + '</strong>')
      .replace('{old}', esc(up.oldLabel));
    var sub = T.upSub
      .replace('{newPrice}', money(up.newPrice))
      .replace('{oldPrice}', money(up.oldPrice))
      .replace('{ship}', money(D.ship.cost));

    return '<div class="nc-cart__up">' +
        '<p class="nc-cart__up-title">' + title + '</p>' +
        '<p class="nc-cart__up-sub">' + esc(sub) + '</p>' +
        '<button type="button" class="nc-cart__up-btn" data-nc-up="' + esc(up.key) + '" data-nc-upq="' + up.newQty + '">' +
          esc(T.upBtn.replace('{new}', up.newLabel)) +
        '</button>' +
      '</div>';
  }

  function upsellHTML() {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var list = D.upsell.filter(function (p) { return !inCart[p.product]; }).slice(0, 6);
    if (!list.length) return '';
    return (
      '<section class="nc-cart__ups">' +
        '<h3>' + esc(T.upsell) + '</h3>' +
        '<div class="nc-cart__ups-row">' +
          list.map(function (p) {
            var btn = p.single
              ? '<button type="button" class="nc-cart__ups-btn" data-nc-add="' + p.variant + '" data-nc-addq="' + stepFor(p.handle) + '">' + esc(T.add) + '</button>'
              : '<a class="nc-cart__ups-btn" href="' + esc(p.url) + '">' + esc(T.choose) + '</a>';
            return (
              '<div class="nc-cart__ups-card">' +
                '<a href="' + esc(p.url) + '" class="nc-cart__ups-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>' +
                '<div class="nc-cart__ups-info">' +
                  '<a href="' + esc(p.url) + '" class="nc-cart__ups-name">' + esc(p.title) + '</a>' +
                  '<p>' + (p.compare > p.price ? '<s>' + money(p.compare) + '</s> ' : '') + money(p.price) + '</p>' +
                  btn +
                '</div>' +
              '</div>'
            );
          }).join('') +
        '</div>' +
      '</section>'
    );
  }

  function render() {
    var count = productCount(cart);
    titleEl.textContent = T.title + ' • ' + count;
    updateBubble(count);

    if (!count) {
      setExp(0);
      bodyEl.innerHTML =
        '<div class="nc-cart__empty"><p>' + esc(T.empty) + '</p>' +
        '<button type="button" class="nc-cart__cta" data-nc-close>' + esc(T.continue) + '</button></div>';
      footEl.hidden = true;
      renderTimer();
      return;
    }

    if (!getExp()) setExp(Date.now() + RESERVE_MS);
    startTimer();

    /* Uppgraderingskortet ligger sist, under korsförsäljningen, närmast kassaknappen
       (Katarinas önskemål 2026-09-16 – gäller båda språken, samma rendering). */
    var items = cart.items.filter(function (it) { return it.variant_id !== PROT; });
    bodyEl.innerHTML = shipHTML() + '<ul class="nc-cart__items">' + items.map(lineHTML).join('') + '</ul>' + upsellHTML() + upgradeHTML();

    /* rabatter summerade per rabatt */
    var disc = {};
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var k = tag(a.discount_application.title);
        disc[k] = (disc[k] || 0) + a.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      var k = tag(a.title);
      disc[k] = (disc[k] || 0) + a.total_allocated_amount;
    });
    var discTotal = Object.keys(disc).reduce(function (n, k) { return n + disc[k]; }, 0);
    var hasProt = cart.items.some(function (it) { return it.variant_id === PROT; });

    footEl.hidden = false;
    footEl.innerHTML =
      (PROT && D.protectionOffer
        ? '<label class="nc-cart__prot">' + icoBox +
            '<span class="nc-cart__prot-txt"><strong>' + esc(T.protection) + '<span>' + money(D.protection.price) + '</span></strong>' +
            '<small>' + esc(T.protectionText) + '</small></span>' +
            '<input type="checkbox" class="nc-cart__switch" data-nc-prot' + (hasProt ? ' checked' : '') + '>' +
          '</label>'
        : '') +
      (discTotal > 0
        ? '<div class="nc-cart__row nc-cart__row--disc"><span>' + esc(T.discounts) + '</span><span class="nc-cart__tags">' +
            Object.keys(disc).map(function (k) { return '<span class="nc-cart__tag">' + icoTag + esc(k) + '</span>'; }).join('') +
          '</span><span>- ' + money(discTotal) + '</span></div>'
        : '') +
      '<div class="nc-cart__row nc-cart__row--total"><span>' + esc(T.total) + '</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a class="nc-cart__cta" href="' + ROOT + 'checkout">' + esc(T.checkout) + ' • ' + money(cart.total_price) + '</a>';
  }

  function updateBubble(count) {
    document.querySelectorAll('cart-icon').forEach(function (el) {
      if (typeof el.renderCartBubble === 'function') el.renderCartBubble(count, false);
    });
  }

  /* ---------- flöden ---------- */
  function load() {
    return api('cart.js').then(function (c) {
      cart = c;
      /* fraktskydd erbjuds inte (eller bara fraktskydd kvar) -> ta bort det */
      var hasProt = PROT && c.items.some(function (it) { return it.variant_id === PROT; });
      if (!(hasProt && (!D.protectionOffer || productCount(c) === 0))) return c;
      var u = {}; u[PROT] = 0;
      return api('cart/update.js', { updates: u }).then(function (c2) { cart = c2; return c2; });
    }).then(function (c) {
      /* parprodukter: antal utanför stegen (1 st, 4 st ...) rundas upp till närmaste
         rabattsteg eller hela par – annars hamnar kunden på ett antal utan eget pris */
      var u = {};
      c.items.forEach(function (it) {
        var fixed = qtyFix(it.handle, it.quantity);
        if (fixed !== it.quantity) u[it.key] = fixed;
      });
      if (!Object.keys(u).length) return;
      return api('cart/update.js', { updates: u }).then(function (c2) {
        cart = c2;
        snapped = true;
      });
    });
  }
  function busy(on) { panel.classList.toggle('is-busy', on); }

  var snapped = false; /* sidladdningen rundade upp ett antal */
  var inflight = null;
  function refresh() {
    if (inflight) return inflight;
    busy(true);
    inflight = load().then(render).catch(function () {}).then(function () { busy(false); inflight = null; });
    return inflight;
  }

  function open(justAdded) {
    if (justAdded) setExp(Date.now() + RESERVE_MS);
    if (root.hidden) {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('nc-cart-open');
      requestAnimationFrame(function () { root.classList.add('is-open'); panel.focus(); });
    }
    return refresh();
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('nc-cart-open');
    setTimeout(function () { root.hidden = true; }, 280);
    clearInterval(tick); tick = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function mutate(p) {
    busy(true);
    return p.then(load).then(render).catch(function (e) {
      bodyEl.insertAdjacentHTML('afterbegin', '<p class="nc-cart__err">' + esc(e.message || T.error) + '</p>');
    }).then(function () { busy(false); });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nc-close],[data-nc-qty],[data-nc-add],[data-nc-up]');
    if (!t) return;
    if (t.hasAttribute('data-nc-close')) return close();
    if (t.hasAttribute('data-nc-qty')) {
      var key = t.closest('[data-key]').getAttribute('data-key');
      return mutate(api('cart/change.js', { id: key, quantity: Number(t.getAttribute('data-nc-qty')) }));
    }
    if (t.hasAttribute('data-nc-up')) {
      setExp(Date.now() + RESERVE_MS);
      return mutate(api('cart/change.js', { id: t.getAttribute('data-nc-up'), quantity: Number(t.getAttribute('data-nc-upq')) }));
    }
    if (t.hasAttribute('data-nc-add')) {
      setExp(Date.now() + RESERVE_MS);
      return mutate(api('cart/add.js', { items: [{ id: Number(t.getAttribute('data-nc-add')), quantity: Number(t.getAttribute('data-nc-addq')) || 1 }] }));
    }
  });
  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-nc-prot]')) return;
    var u = {}; u[PROT] = e.target.checked ? 1 : 0;
    mutate(api('cart/update.js', { updates: u }));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  /* Länkar till /cart öppnar lådan i stället (utom på själva kundvagnssidan) */
  function isCartPath(path) {
    return path === ROOT + 'cart' || path === ROOT + 'cart/' || path === '/cart';
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || root.contains(a) || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var u = new URL(a.href, location.href);
    if (u.origin !== location.origin || !isCartPath(u.pathname) || isCartPath(location.pathname)) return;
    e.preventDefault();
    open(false);
  }, true);

  /* Vanliga produktformulär som postar till /cart/add */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f.action || f.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    nativeFetch(ROOT + 'cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || T.error); }); })
      .then(function () { open(true); })
      .catch(function (err) { alert(err.message); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* Temats egna AJAX-köp (snabbköp m.m.) öppnar också lådan */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && (init.headers['X-NC-Cart'] || (init.headers.get && init.headers.get('X-NC-Cart')));
    var p = nativeFetch(input, init);
    if (!mine && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r.ok) setTimeout(function () { open(true); }, 50); });
    }
    return p;
  };

  /* Antal utanför stegen (t.ex. 3 st) rundades bara upp när lådan öppnades, så en kund
     kunde gå till kassan med 3 st från /cart. Nu snappas kundvagnen redan vid sidladdning. */
  /* /cart renderas av servern, så ett uppsnappat antal syns först efter en omladdning
     (annars står det 3 st / 698 kr på sidan medan kundvagnen är 6 st / 499 kr). */
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  /* Shopifys egen varukorgssida saknar fri frakt-mätaren och uppgraderingskortet
     ("För 61 kr extra får du fri frakt och 3 par ..."). I stället för att bygga samma
     logik en gång till i Liquid öppnas lådan direkt – då ser /cart likadant ut på
     svenska och norska som när kunden lägger i varukorgen. Katarinas krav 2026-09-16. */
  function initialLoad() {
    return load().then(function () {
      if (snapped && onCartPage()) return location.reload();
      if (onCartPage() && cart && cart.item_count > 0) return open();
    }).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialLoad);
  } else {
    initialLoad();
  }

  window.NCCart = { open: open, close: close, refresh: refresh };

  var icoTag = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8.6 1.5H14.5v5.9L7.4 14.5 1.5 8.6z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="11.2" cy="4.8" r="1.1" fill="currentColor"/></svg>';
  var icoTrash = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3.5 5.5h13M8 5.5V3.8h4v1.7M5 5.5l.8 11h8.4l.8-11M8.3 8.5v5.5M11.7 8.5v5.5" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var icoTruck = '<svg class="nc-cart__ship-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M1.8 6.2h11.4v9.9H1.8zM13.2 9.4h4.2l2.8 3.3v3.4h-7z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="6.4" cy="17.6" r="1.9" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="16.6" cy="17.6" r="1.9" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  var icoBox = '<svg class="nc-cart__prot-ico" viewBox="0 0 48 48" aria-hidden="true"><path d="M6 14l16-8 16 8v18l-16 8-16-8z" fill="#e4e7e6" stroke="#8c9594" stroke-width="1.5" stroke-linejoin="round"/><path d="M6 14l16 8 16-8M22 22v18" fill="none" stroke="#8c9594" stroke-width="1.5"/><circle cx="36" cy="34" r="10" fill="#1f6fd6"/><path d="M31.5 34.2l3.2 3.1 5.8-6" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
})();
